import { render, staticRenderFns } from "./vehicleStatusView.vue?vue&type=template&id=463ddee0&scoped=true&"
import script from "./vehicleStatusView.vue?vue&type=script&lang=js&"
export * from "./vehicleStatusView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ddee0",
  null
  
)

export default component.exports